angular.module('Directives')
    .directive('ngTableLite',
        function (Shipments, toastr) {
            return {
                restrict: 'E',
                templateUrl: '/templates/directives/ngTableLite.html',
                replace: true,
                scope: {
                    tableData: '=',
                    class: '@',
                    ngDisabled: '=?',
                },
                controller: ngTableCtrl
            };

            function ngTableCtrl(
                $scope, 
                $element, 
                $attrs, 
                $uibModal, 
                $window, 
                aborter, 
                $filter, 
                TableTemplateUrls,
                $timeout
            ) {
                $scope.getItemList = getItemList;
                $scope.configure = configure;
                $scope.selectAllchekboxes = selectAllchekboxes;
                $scope.isActionCell = isActionCell;
                $scope.hasActiveFilter = hasActiveFilter;
                $scope.onEnterKeyPress = onEnterKeyPress;
                $scope.countSelected = countSelected;
                $scope.refresh = refresh;
                $scope.getSortClass = getSortClass;
                $scope.getFilterTooltip = getFilterTooltip;
                $scope.extractTable = extractTable;
                $scope.resetToDefaults = resetToDefaults;
                $scope.extractOptions = [];
                $scope.noFilter = true;
                $scope.defaultWidth = null;
                $scope.templatesUrls = TableTemplateUrls;
                $scope.viewList = [5, 10, 15, 20, 25, 50, 100];
                $scope.extractTimeout = 10000;

                $scope.datePickers = {};
                $scope.datePicker = {
                    fromDate: {
                        opened: false,
                        options: {
                            formatYear: 'yy',
                            startingDay: 1,
                            maxDate: new Date()
                        },
                        onChange: function (header) {
                            $scope.datePicker.toDate.options.minDate = new Date(header.filter.fromModel);
                            if (!header.filter.toModel) {
                                header.filter.toModel = new Date();
                            }
                            header.filter.onSubmit(header);
                        }
                    },
                    toDate: {
                        opened: false,
                        options: {
                            formatYear: 'yy',
                            startingDay: 1,
                            maxDate: new Date()
                        },
                        onChange: function (header) {
                            if (!header.filter.fromModel) {
                                header.filter.fromModel = new Date(0);
                            }
                            header.filter.onSubmit(header);
                        }
                    },
                    openToDate: function () {
                        $scope.datePicker.toDate.opened = true;
                    },
                    openFromDate: function () {
                        $scope.datePicker.fromDate.opened = true;
                    }
                };
                $scope.$watch('tableData.headers.length', function (length) {
                    let portion = 100 / length;
                    $scope.defaultWidth = portion + '%';
                });

                let extractOptions = {
                    csv: {
                        label: 'CSV',
                        value: 'csv'
                    },
                    pdf: {
                        label: 'PDF',
                        value: 'pdf'
                    }
                };
                let watchHeaders = $scope.$watch('tableData', setHeaders);
                let modalProperties = {
                    animation: true,
                    windowClass: 'table-config-modal',
                    ariaDescribedBy: 'modal-body',
                    templateUrl: '/templates/directives/intellectual-table/tableConfigurationModal.html',
                    controller: function ($uibModalInstance) {
                        let scope = this;
                        scope.included = $scope.included;
                        if ($scope.tableData) {
                            angular.extend(scope, $scope.tableData);
                        }

                        scope.save = function () {
                            angular.forEach(scope.included, function (header, index) {
                                $scope.tableData.headers[index].include = !!header;
                            });
                            $window.localStorage.setItem($scope.tableData.tableName, JSON.stringify(scope.included));
                            $uibModalInstance.close();
                        };
                        scope.dismiss = ()=>{
                            $uibModalInstance.dismiss();
                        }

                    },
                    controllerAs: 'tc',
                    size: 'md'
                };

                function onEnterKeyPress($event, header) {
                    let keyCode = $event.which || $event.keyCode;
                    if (keyCode === 13) {
                        header.filter.onSubmit(header);
                    }
                }

                function setHeaders() {
                    if ($scope.tableData) {
                        $scope.testAffix = $attrs.tableData;
                        if ($scope.tableData.tableName && $window.localStorage.getItem($scope.tableData.tableName)) {
                            $scope.included = JSON.parse($window.localStorage.getItem($scope.tableData.tableName));
                        } else {
                            $scope.included = [];
                        }
                        if ($scope.tableData && $scope.tableData.headers) {
                            angular.forEach($scope.tableData.headers, function (header, index) {
                                if ($scope.tableData.tableName && $window.localStorage.getItem($scope.tableData.tableName)) {
                                    header.include = $scope.included[index]
                                } else {
                                    header.include = true;
                                    $scope.included.push(header.include);
                                }
                                if ($scope.noFilter && header.filter) {
                                    $scope.noFilter = false;
                                }
                            });
                            watchHeaders();
                        }
                    }
                }

                function hasActiveFilter() {
                    return !!$scope.tableData && !$scope.tableData.headers.every((header) => {
                        return !angular.getObjVal(header, 'filter.model') && !angular.getObjVal(header, 'filter.toModel') && !angular.getObjVal(header, 'filter.fromModel');
                    });
                }

                function getItemList(search) {
                    // TODO: UNCOMMENT THIS ONE IF THIS CAUSES AN ISSUE
                    // if (search > 100)
                    //     search = 100;

                    let newCount = $scope.viewList.slice();

                    if (search && newCount.indexOf(search) === -1) {
                        newCount.unshift(search);
                    }
                    return newCount;
                }

                function refresh(headerFilter, select) {
                    if (!select.open && !headerFilter.refreshOnLoad) {
                        return false;
                    }
                    $scope.autocompleteFetching = true;
                    if (headerFilter.items)
                        headerFilter.items.length = 0;
                    aborter(() => {
                        try {
                            headerFilter.refresh(select.search).then(() => {
                                $scope.autocompleteFetching = false;
                            });
                        } catch (e) {
                            $scope.autocompleteFetching = false;
                        }
                    }, 500);
                }
                
                function toTitleCase(str){
                    return str.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
                }

                function getFilterTooltip(header) {
                    if(!angular.getObjVal(header, 'filter.type') || !header.label){
                        return null;
                    }
                    let tooltip = $filter('translate')('messages.info.tooltip.table.filter.' + header.filter.type.toUpperCase());

                    switch (header.filter.type){
                        case 'text':
                        case 'select2':
                        case 'autoComplete':
                        case 'inputDropdown':
                        case 'datePicker':
                            tooltip =  tooltip + ' ' + header.label.toUpperCase().replace('<SUP>', '^').replace('</SUP>', '');
                            break;
                        case 'button':
                        case 'checkbox':
                            break;
                        default:
                            tooltip = null;
                    }
                    return tooltip;
                }

                function extractTable(selected) {
                    if(selected && selected.value === 'csv') {
                        const selectedShipments = $scope.tableData.data.filter(data => data.isSelected);
                        if (selectedShipments.length > 0) {
                            downloadShipmentsById($scope.tableData.data);
                        } else {
                            downloadAllShipments();
                        }
                    }
                }

                function downloadShipmentsById(shipments){
                    $scope.extractingData = true;
                    const fileName = ($scope.tableData.config.extractFileName || $scope.tableData.tableName || 'table') + '.csv';
                    
                    const selectedShipments = shipments.filter(data => data.isSelected);
                    const ids = selectedShipments.map(data => {
                        return data.id;
                    });
                    
                    const params = {};
                    if(angular.getObjVal($scope.tableData, 'sort.direction')) {
                        params.sort = `${$scope.tableData.sort.filterName},${$scope.tableData.sort.direction}`;
                    } 

                    Shipments.exportByIds(fileName, {}, params, ids, data => {
                        $timeout(() => {
                            $scope.extractingData = false;
                            showNotificationMessage(
                                'CSV report extraction is underway.', 
                                "Download your file from the notification bell once it's ready."
                            );
                        }, $scope.extractTimeout);
                    }, error=>{
                        toastr.error(error.message, "Error");
                        $scope.extractingData = false;
                    });
                }

                function downloadAllShipments() {
                    $scope.extractingData = true;
                    
                    const filters = {};
                    const activeFilters = $scope.tableData.headers.filter(dat => {
                        return angular.getObjVal(dat, 'filter.model') || angular.getObjVal(dat, 'filter.toModel') || angular.getObjVal(dat, 'filter.fromModel');
                    });
                    activeFilters.forEach(data => {
                        const filterName = data.filterName;
                        if (data.filter.type === 'datePicker') {
                            switch(filterName) {
                                case 'createdDate':
                                    filters['createdDateStart'] = data.filter.fromModel.toISOString();
                                    filters['createdDateEnd'] = data.filter.toModel.toISOString();
                                break;
                                case 'manifestedDate': 
                                    filters['manifestedDateStart'] = data.filter.fromModel.toISOString();
                                    filters['manifestedDateEnd'] = data.filter.toModel.toISOString();
                                break;
                            }  
                        } else {
                            switch(filterName) {
                                case 'customerReferences':
                                    filters['customerReference'] = data.filter.model;
                                break;
                                case 'bbConsignmentId': 
                                    filters['consignmentId'] = data.filter.model;
                                break;
                                case 'paymentDetails.receiptNumber': 
                                    filters['paymentReceiptNumber'] = data.filter.model;
                                break;
                                case 'job.id':
                                    filters['jobId'] = data.filter.model; 
                                break;
                                case 'carrierProfileId':
                                    filters['carrierProfileId'] = data.filter.model.id;
                                break;
                                case 'serviceProfileId':
                                    filters['serviceProfileId'] = data.filter.model.id;
                                break;
                                default: 
                                    filters[data.filterName] = data.filter.model;
                            }
                        }
                    });

                    Shipments.exportCSV(null, [], null, filters, response => {
                        $timeout(() => {
                            $scope.extractingData = false;
                            showNotificationMessage(
                                'CSV report extraction is underway.', 
                                "Download your file from the notification bell once it's ready."
                            );
                        }, $scope.extractTimeout);
                    });
                }

                function showNotificationMessage(title, message) {
                    $uibModal.open({
                        animation: true,
                        ariaLabelledBy: 'modal-title',
                        ariaDescribedBy: 'modal-body',
                        windowClass: 'setting-modal',
                        templateUrl: '/templates/modal/notification-modal.html',
                        controller: 'NotificationModalController',
                        controllerAs: 'vm',
                        size: 'md',
                        appendTo: $('body'),
                        resolve: {
                            title: () => title,
                            message: () => message
                        }
                    });
                }

                function resetToDefaults() {
                    $scope.datePicker.toDate.options.minDate = null;

                    // clear the select filters data
                    if($scope.tableData.optionAddOns){
                        if($scope.tableData.optionAddOns.selectFilters){
                            $scope.tableData.optionAddOns.selectFilters.forEach(data=>{
                                data.ngModel = { label: 'N/A'};
                            });
                        }
                    }
                }

                function configure() {
                    $uibModal.open(modalProperties).result.then(() => {
                    }, () => {
                        setHeaders();
                    });
                }

                function isActionCell(row, header) {
                    if (angular.getObjVal(header, 'filter.type') === 'checkbox') {
                        return '/templates/directives/intellectual-table/body-cells/checkbox.html';
                    } else if ($scope.templatesUrls.actionBody[angular.getObjVal(row, [header.viewName] + '.type')]) {
                        return $scope.templatesUrls.actionBody[angular.getObjVal(row, [header.viewName] + '.type')];
                    }
                    return false;
                }

                function selectAllchekboxes() {
                    if ($scope.tableData.isAllSelected) {
                        angular.forEach($scope.tableData.data, function (row) {
                            row.isSelected = true;
                        });
                    } else {
                        angular.forEach($scope.tableData.data, function (row) {
                            row.isSelected = false;
                        });
                    }
                }

                function countSelected(rows) {
                    if(rows){
                        $scope.tableData.isAllSelected = rows.every(row=>{
                           return row.isSelected;
                        });
                    }
                }

                function getSortClass(header) { 
                    if(!$scope.tableData.sort) return '';
                    var sortParam = $scope.tableData.sort.filterName;
                    
                    if (sortParam !== header.filterName || sortParam !== header.sortName || !angular.getObjVal($scope.tableData, 'sort.direction')) {
                        return ''; 
                    }

                    return $scope.tableData.sort.direction.toLowerCase();

                }

                function setDateFilters(viewName) {
                    $scope.datePickers[viewName] = {
                        fromDate: {
                            opened: false,
                            options: {
                                formatYear: 'yy',
                                startingDay: 1,
                                maxDate: new Date()
                            },
                            onChange: function (header) {
                                $scope.datePickers[viewName].toDate.options.minDate = new Date(header.filter.fromModel);
                                if (!header.filter.toModel) {
                                    header.filter.toModel = new Date();
                                }
                                header.filter.onSubmit(header);
                            }
                        },
                        toDate: {
                            opened: false,
                            options: {
                                formatYear: 'yy',
                                startingDay: 1,
                                maxDate: new Date()
                            },
                            onChange: function (header) {
                                if (!header.filter.fromModel) {
                                    header.filter.fromModel = new Date(0);
                                }
                                header.filter.onSubmit(header);
                            }
                        },
                        openToDate: function () {
                            $scope.datePickers[viewName].toDate.opened = true;
                        },
                        openFromDate: function () {
                            $scope.datePickers[viewName].fromDate.opened = true;
                        }
                    }
                }

                function init() {
                    if(angular.getObjVal($scope, 'tableData.config.extraction.length')){
                        $scope.tableData.config.extraction.forEach(input=>{
                            if(angular.isObject(input))
                                $scope.extractOptions.push(angular.extend(extractOptions[input.type], {
                                    advanced: input.advanced
                                }));
                            else
                                $scope.extractOptions.push(extractOptions[input]);
                        });
                        if($scope.extractOptions.length)
                            $scope.tableData.selectedExtraction = $scope.extractOptions[0];
                    }

                    const dateFitlers = $scope.tableData.headers.filter(header => angular.getObjVal(header, 'filter.type') === 'datePicker');
                    dateFitlers.forEach(filter => {
                        setDateFilters(filter.viewName);
                    });
                }

                init();
            }
        });



// WEBPACK FOOTER //
// ./js/directives/ngTableLite.js